import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';
export var AllOptions = [{
  label: 'Buy',
  value: ListingType.SALES_RESIDENTIAL.name
}, {
  label: 'New Homes',
  value: ListingType.DEVELOPMENTS_RESIDENTIAL.name
}, {
  label: 'Rent',
  value: ListingType.RENTAL_RESIDENTIAL.name
}, {
  label: 'Share',
  value: ListingType.SHARE_RESIDENTIAL.name
}, {
  label: 'For Sale',
  value: ListingType.SALES_COMMERCIAL.name
}, {
  label: 'For Lease',
  value: ListingType.RENTAL_COMMERCIAL.name
}, {
  label: 'Business',
  value: ListingType.SALES_BUSINESS.name
}];
export var optionsForListingType = listingType => {
  var _ListingType$listingT;
  var isCommercial = (_ListingType$listingT = ListingType[listingType]) === null || _ListingType$listingT === void 0 ? void 0 : _ListingType$listingT.isCommercial;
  return AllOptions.filter(option => ListingType[option.value].isCommercial ? isCommercial : !isCommercial);
};